module.exports = __webpack_public_path__ + "static/media/1.0e827f85.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/400/1.png
// module id = 729
// module chunks = 0